<ng-container *ngIf="userData.length && !isLoading">
  <div
    class="
      nk-shared-user-infos-small
      suggestion-list
      d-flex
      align-items-center
      p-3
    "
    *ngFor="let data of userData; let i = index"
  >
    <datnek-ds-avatar
      [size]="sizeEnum.medium1"
      imgSrc="{{ data.imageSrc }}"
      class="mr-3"
      [type]="status"
    ></datnek-ds-avatar>

    <!-- IF TYPE === SOCIETY -->
    <ng-container *ngIf="status === 'society'">
      <a
        class="pointer infos d-block w-100"
        target="_blank"
        href="https://dev-home.delenscio.be/user/enterprise/private/about/general-informations"
      >
        <div class="d-flex flex-column">
          <div class="d-flex">
            <div class="name display-4 d-inline mr-2">
              {{ data.society }}
              <img src="assets/icons/src/check-color.png" alt="" />
            </div>
          </div>
          <span>{{ data.sector }}</span>
        </div>
      </a>

      <datnek-ds-button-icon
        [type]="colorEnum.primary"
        [size]="sizeEnum.medium"
        [Icon]="iconEnum.outlineWhiteofficeAdd"
        (datnekdsClickOrTouch)="isFollowed(i)"
        *ngIf="follow === false && status === 'society'"
      ></datnek-ds-button-icon>
      <datnek-ds-button-icon
        [type]="colorEnum.secondary"
        [size]="sizeEnum.medium"
        [Icon]="iconEnum.outlinecheck"
        (datnekdsClickOrTouch)="isFollowed(i)"
        *ngIf="follow === true && status === 'society'"
      ></datnek-ds-button-icon>
    </ng-container>

    <!-- IF STATUS === PERSON -->
    <ng-container *ngIf="status === 'person'">
      <div class="infos pointer p-0" target="_blank">
        <ng-container (datnekdsClickOrTouch)="gotoProfile($event)" *ngIf="link">
          <div class="d-flex flex-column">
            <div class="d-flex">
              <div class="name display-2 mr-2">
                {{ data.name | truncatetext: 15
                }}<img src="assets/icons/src/check-color.png" alt="" />
              </div>
            </div>
            <span>{{ data.professionalTitle }} à {{ data.society }}</span>
            <span id="relations" class="display-8">
              {{ data.relations }} relations en commun
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="!link">
          <div class="d-flex flex-column">
            <div class="d-flex">
              <div class="name display-2 mr-2">
                {{ data.name | truncatetext: 15
                }}<img src="assets/icons/src/check-color.png" alt="" />
              </div>
            </div>
            <span>{{ data.professionalTitle }} à {{ data.society }}</span>
            <span id="relations" class="display-8">
              {{ data.relations }} relations en commun
            </span>
          </div>
        </ng-container>
      </div>
      <datnek-ds-button-icon
        [type]="colorEnum.primary"
        [size]="sizeEnum.medium"
        [Icon]="iconEnum.outlineWhiteuserAdd"
        (datnekdsClickOrTouch)="isFollowed(i)"
        class=""
        *ngIf="follow === false && status === 'person'"
      ></datnek-ds-button-icon>
      <datnek-ds-button-icon
        [type]="colorEnum.secondary"
        [size]="sizeEnum.medium"
        [Icon]="iconEnum.outlinecheck"
        (datnekdsClickOrTouch)="isFollowed(i)"
        class=""
        *ngIf="follow === true && status === 'person'"
      ></datnek-ds-button-icon>
      <datnek-ds-button
        [type]="colorEnum.primary"
        [size]="sizeEnum.medium"
        label="Message"
        (datnekdsClickOrTouch)="isFollowed(i)"
        *ngIf="sendMessage === true"
        class="ml-3"
      ></datnek-ds-button>
      <div class="roles">
        <div class="d-inline-block roles-dropdown" *ngIf="role === true">
          <button
            (datnekdsClickOrTouch)="openDropdown(actions, origin3)"
            #origin3
          >
            <datnek-ds-button-icon
              [Icon]="iconEnum.outlinedotsVertical"
              [type]="colorEnum.unstyled"
              [size]="sizeEnum.medium"
              id="dropdownBasic2"
              class="ml-3"
            ></datnek-ds-button-icon>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- IF TYPE === GROUP -->
    <ng-container *ngIf="status === 'group'">
      <div
        class="d-flex flex-column pointer"
        (datnekdsClickOrTouch)="gotoGroup($event)"
      >
        <div class="d-flex">
          <div class="name display-4 d-inline mr-2">
            {{ data.groupName }}
          </div>
        </div>
        <span>En ligne il ya 22h</span>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="countSkeleton === 1">
  <ng-container *ngFor="let in of counter(1); let i = index">
    <datnek-skeleton-suggestion-list
      *ngIf="isLoading"
    ></datnek-skeleton-suggestion-list>
  </ng-container>
</ng-container>

<ng-container *ngIf="countSkeleton === 2">
  <ng-container *ngFor="let in of counter(2); let i = index">
    <datnek-skeleton-suggestion-list
      *ngIf="isLoading"
    ></datnek-skeleton-suggestion-list>
  </ng-container>
</ng-container>

<ng-container *ngIf="countSkeleton === 3">
  <ng-container *ngFor="let in of counter(3); let i = index">
    <datnek-skeleton-suggestion-list
      *ngIf="isLoading"
    ></datnek-skeleton-suggestion-list>
  </ng-container>
</ng-container>

<!--NOTIFS MESSAGES-->
<ng-template #adm let-close="close">
  John Doe a été promu comme Administrateur du groupe
</ng-template>
<ng-template #md let-close="close">
  John Doe a été promu comme modérateur du groupe
</ng-template>
<ng-template #del let-close="close">
  John Doe a été retiré du groupe
</ng-template>

<!-- DROPDOWNS -->
<ng-template #actions let-close="close">
  <div class="datnek-ds-card dropdown-card suggestion-members-action">
    <button ngbDropdownItem (datnekdsClickOrTouch)="showToast(adm); close()">
      Ajouter comme Admin
    </button>
    <button ngbDropdownItem (datnekdsClickOrTouch)="showToast(md); close()">
      Ajouter comme modérateur
    </button>
    <button ngbDropdownItem (datnekdsClickOrTouch)="showToast(del); close()">
      Retirer du groupe
    </button>
  </div>
</ng-template>
